import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { InstanceService } from "../services/instance.service";

@Injectable({ providedIn: "root" })
export class DomainNameValidators {
  constructor(private instanceService: InstanceService) {}

  static patternValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value)
        return null;

      const valid = /^[a-z-]+$/i.test(value);
      return valid ? null : { invalidDomainName: true };
    };
  }

  domainAvailabilityValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value)
        return of(null);

      return this.instanceService.checkIfDomainExists(control.value).pipe(
        map((isTaken: boolean) => (isTaken ? { domainTaken: true } : null)),
        catchError(() => of(null)),
      );
    };
  }
}
